import React, { useState, useEffect, useRef } from "react";
import { FiLogIn } from "react-icons/fi"; // Icon pentru Login
import { FaUserPlus } from "react-icons/fa"; // Icon pentru Sign Up
import "./header.css";
import logo_image from "./assets/logo-immens.svg";
import compari_image from "./assets/compari.png";
import alza_image from "./assets/Black.svg";
import LoginModal from "./pages/login";
import SignUpModal from "./pages/signup";
import { Link, animateScroll as scroll } from "react-scroll";
import { FaHome } from "react-icons/fa"; // Icon pentru Home
import { FiMenu, FiX } from "react-icons/fi";
import { AiOutlineLogin } from "react-icons/ai";
import { GiAstronautHelmet } from "react-icons/gi";
import { useAuth } from "./contexts/authContext";
// const sections = ["products", "about", "contact"];
const sections = [];

const Header = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHomeActive, setisHomeActive] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isSignUpOpen, setisSignUpOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleHomeBtn = () => {
    setActiveSection(null);
    setisHomeActive(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNavigation = (section) => {
    console.log(section);
    setisHomeActive(false);
    if (section === "home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setActiveSection(null); // Home NU devine activ
    } else {
      document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
      setActiveSection(section); // Setăm activ doar dacă NU e Home
    }
  };

  useEffect(() => {
    const body = document.body;

    if (isLoginOpen || isSignUpOpen) {
      body.classList.add("no-scroll");
    } else {
      body.classList.remove("no-scroll");
    }

    // cleanup la unmount (în caz că se demontează header-ul cu un modal deschis)
    return () => {
      body.classList.remove("no-scroll");
    };
  }, [isLoginOpen, isSignUpOpen]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      let currentSection = null;
      sections.forEach((section) => {
        const sectionElement = document.getElementById(section);
        if (sectionElement) {
          const { top, bottom } = sectionElement.getBoundingClientRect();
          if (top < window.innerHeight / 2 && bottom > window.innerHeight / 2) {
            currentSection = section;
          }
        }
      });

      setActiveSection(currentSection);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMenuOpen(false); // Închide meniul când ecranul devine mare
      }
    };

    const handleClickOutside = (event) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false); // Închide meniul
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-panel">
        <div className="column-wrapper">
          <img className="alza-image" src={alza_image} alt="" />
          <img className="logo-image" src={logo_image} alt="" />
        </div>

        {/* Butonul hamburger */}
        {isMobile && (
          <button
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <FiX /> : <FiMenu />}
          </button>
        )}

        {/* {!isMobile && (
          <button
            className={`home-button ${isHomeActive ? "active" : ""} ${
              isMenuOpen ? "hidden" : ""
            }`}
            onClick={() => handleHomeBtn()}
          >
            <FaHome className="icon" /> Home
          </button>
        )} */}

        {/* Navbar-ul principal */}
        {!isMobile && (
          <nav className="nav-menu">
            {sections.map((section) => (
              <Link
                key={section}
                to={section}
                smooth={true}
                duration={500}
                className={`nav-item ${
                  activeSection === section ? "active" : ""
                }`}
              >
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </Link>
            ))}
          </nav>
        )}

        {!isMobile && (
          <div
            className={`auth-buttons header-actions ${
              isMenuOpen ? "hidden" : ""
            }`}
          >
            {user ? (
              <div className="user-menu">
                <button
                  className="user-menu-trigger"
                  onClick={() => setIsUserMenuOpen((prev) => !prev)}
                >
                  <div className="user-avatar">
                    {(user.email?.[0] || "U").toUpperCase()}
                  </div>
                  <span className="user-email-label">{user.email}</span>
                </button>

                {isUserMenuOpen && (
                  <div className="user-dropdown">
                    <div className="user-dropdown-header">
                      <div className="user-avatar large">
                        {(user.email?.[0] || "U").toUpperCase()}
                      </div>
                      <div className="user-dropdown-text">
                        <div className="user-dropdown-email">{user.email}</div>
                        {user.company && (
                          <div className="user-dropdown-company">
                            {user.company}
                          </div>
                        )}
                        {user.codFiscal && (
                          <div className="user-dropdown-cod">
                            Cod fiscal: {user.codFiscal}
                          </div>
                        )}
                      </div>
                    </div>

                    <button
                      className="logout-btn"
                      onClick={() => {
                        setIsUserMenuOpen(false);
                        logout();
                      }}
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="auth-buttons header-actions">
                <button className="btn" onClick={() => setIsLoginOpen(true)}>
                  <AiOutlineLogin className="icon" /> Login
                </button>
                <button
                  className="btn signup"
                  onClick={() => setisSignUpOpen(true)}
                >
                  <GiAstronautHelmet className="icon" /> Sign Up
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {isMenuOpen && (
        <div
          ref={menuRef}
          className={`mobile-menu ${isMenuOpen ? "open" : "closed"}`}
        >
          {/* <button
            className="home-button-menu"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              setActiveSection(null);
              setIsMenuOpen(false);
            }}
            
          >
          Home
          </button> */}
          {sections.map((section) => (
            <Link
              key={section}
              to={section}
              smooth={true}
              duration={500}
              className={`nav-item ${
                activeSection === section ? "active" : ""
              }`}
              onClick={() => setIsMenuOpen(false)} // Închide meniul după selectare
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </Link>
          ))}
          <button
            className="btn mobile-login"
            onClick={() => {
              setIsLoginOpen(true);
              setIsMenuOpen(false);
            }}
          >
            <FiLogIn className="icon" /> Login
          </button>
          <button
            className="btn signup mobile-signup"
            onClick={() => {
              setisSignUpOpen(true);
              setIsMenuOpen(false);
            }}
          >
            <FaUserPlus className="icon" /> Sign Up
          </button>
        </div>
      )}

      <LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
      <SignUpModal
        isOpen={isSignUpOpen}
        onClose={() => setisSignUpOpen(false)}
      />
    </header>
  );
};

export default Header;
